import { QueryLanguage } from "@contember/binding";
const getColumnFilter = (column, artifact, environment) => {
  if (column.enableFiltering === false || artifact === void 0) {
    return void 0;
  }
  const sugaredFilter = column.getNewFilter(artifact, {
    environment
  });
  if (sugaredFilter === void 0) {
    return void 0;
  }
  return QueryLanguage.desugarFilter(sugaredFilter, environment);
};
export {
  getColumnFilter
};
//# sourceMappingURL=getColumnFilter.js.map
